import { IFormData } from './types';
import { epassprotFetch } from '@common/services/fetch';


export function updateUserPassword(formData: IFormData): any {
  return epassprotFetch.put('/account/resetPassword', formData);
}
